const ENGLISH = $localize`:@@language-mapping.english:English - United States`;
const ARABIC = $localize`:@@language-mapping.arabic:Arabic`;
const SIMPLIFIED_CHINESE = $localize`:@@language-mapping.chinese:Chinese - Simplified`;
const TRADITIONAL_CHINESE = $localize`:@@language-mapping.traditional-chinese:Chinese - Traditional`;
const DANISH = $localize`:@@language-mapping.danish:Danish`;
const FRENCH = $localize`:@@language-mapping.french:French`;
const HUNGARIAN = $localize`:@@language-mapping.hungarian:Hungarian`;
const KOREAN = $localize`:@@language-mapping.korean:Korean`;
const PORTUGUESE_BRAZIL = $localize`:@@language-mapping.portuguese:Portuguese - Brazil`;
const SPANISH = $localize`:@@language-mapping.spanish:Spanish`;
const TURKISH = $localize`:@@language-mapping.turkish:Turkish`;
const GERMAN = $localize`:@@language-mapping.german:German`;
const DUTCH = $localize`:@@language-mapping.dutch:Dutch`;
const INDONESIAN = $localize`:@@language-mapping.indonesian:Indonesian`;
const NORWEGIAN = $localize`:@@language-mapping.norsk:Norwegian`;
const ROMANIAN = $localize`:@@language-mapping.romanian:Romanian`;
const SPANISH_MEXICO = $localize`:@@language-mapping.spanish-mexico:Spanish - Mexico‏`;
const UKRAINIAN = $localize`:@@language-mapping.ukrainian:Ukrainian`;
const GREEK = $localize`:@@language-mapping.greek:Greek`;
const ITALIAN = $localize`:@@language-mapping.italian:Italian`;
const POLISH = $localize`:@@language-mapping.polish:Polish`;
const RUSSIAN = $localize`:@@language-mapping.russian:Russian`;
const SWEDISH = $localize`:@@language-mapping.swedish:Swedish`;
const VIETNAMESE = $localize`:@@language-mapping.vietnamese:Vietnamese`;
const CZECH = $localize`:@@language-mapping.czech:Czech`;
const FINNISH = $localize`:@@language-mapping.finnish:Finnish`;
const HEBREW = $localize`:@@language-mapping.hebrew:Hebrew`;
const JAPANESE = $localize`:@@language-mapping.japanese:Japanese`;
const PORTUGUESE_PORTUGAL = $localize`:@@language-mapping.portuguese-portugal:Portuguese - Portugal`;
const SLOVAK = $localize`:@@language-mapping.slovak:Slovak‏`;
const THAI = $localize`:@@language-mapping.thai:Thai`;
const ICELANDIC = $localize`:@@language-mapping.icelandic:Icelandic`;

export const LANGUAGE_MAPPINGS = [
  {
    langCode: 'en-US',
    langName: 'English - United States',
    langInEng: ENGLISH
  },
  
  {
    langCode: 'ar-sa',
    langName: 'اللغة العربية',
    langInEng: ARABIC
  },
  {
    langCode: 'zh-Hans',
    langName: '简体中文‏',
    langInEng: SIMPLIFIED_CHINESE
  },
  {
    langCode: 'zh-Hant',
    langName: '繁體中文‏',
    langInEng: TRADITIONAL_CHINESE
  },
  {
    langCode: 'cs',
    langName: 'Čeština‏',
    langInEng: CZECH
  },
  {
    langCode: 'da',
    langName: 'Dansk',
    langInEng: DANISH
  },
  {
    langCode: 'nl',
    langName: 'Nederlands‏',
    langInEng: DUTCH
  },
  {
    langCode: 'fi',
    langName: 'Suomi‏',
    langInEng: FINNISH
  },
  {
    langCode: 'fr',
    langName: 'Français',
    langInEng: FRENCH
  },
  {
    langCode: 'de',
    langName: 'Deutsch‏',
    langInEng: GERMAN
  },
  {
    langCode: 'el',
    langName: 'Ελληνικά‏',
    langInEng: GREEK
  },
  {
    langCode: 'he',
    langName: 'עברית‏',
    langInEng: HEBREW
  },
  {
    langCode: 'hu',
    langName: 'Magyar',
    langInEng: HUNGARIAN
  },
  {
    langCode: 'is',
    langName: 'íslenskur‏',
    langInEng: ICELANDIC
  },
  {
    langCode: 'id',
    langName: 'Bahasa Indonesia‏',
    langInEng: INDONESIAN
  },
  {
    langCode: 'it',
    langName: 'Italiano‏',
    langInEng: ITALIAN
  },
  {
    langCode: 'ja',
    langName: '日本語',
    langInEng: JAPANESE
  },
  {
    langCode: 'ko',
    langName: '한국어‏',
    langInEng: KOREAN
  },
  {
    langCode: 'nb',
    langName: 'Norsk',
    langInEng: NORWEGIAN
  },
  {
    langCode: 'pl',
    langName: 'Polski‏',
    langInEng: POLISH
  },
  {
    langCode: 'pt-br',
    langName: 'Português (Brasil)‏',
    langInEng: PORTUGUESE_BRAZIL
  },
  {
    langCode: 'pt',
    langName: 'Português (Portugal)‏',
    langInEng: PORTUGUESE_PORTUGAL
  },
  {
    langCode: 'ro',
    langName: 'Română‏',
    langInEng: ROMANIAN
  },
  {
    langCode: 'ru',
    langName: 'Русский‏',
    langInEng: RUSSIAN
  },
  {
    langCode: 'sk',
    langName: 'Slovenčina‏',
    langInEng: SLOVAK
  },
  {
    langCode: 'es-mx',
    langName: 'Español (México)',
    langInEng: SPANISH_MEXICO
  },
  {
    langCode: 'es',
    langName: 'Español (España)‏',
    langInEng: SPANISH
  },
  {
    langCode: 'sv',
    langName: 'Svenska‏',
    langInEng: SWEDISH
  },
  {
    langCode: 'th',
    langName: 'ไทย‏',
    langInEng: THAI
  },
  {
    langCode: 'tr',
    langName: 'Türkçe‏',
    langInEng: TURKISH
  },
  {
    langCode: 'uk',
    langName: 'Українська‏',
    langInEng: UKRAINIAN
  },
  {
    langCode: 'vi',
    langName: 'Tiếng Việt‏',
    langInEng: VIETNAMESE
  }
];
